<template>
  <!-- 设置时间 是否启用邮箱 -->
  <div style="padding: 10px 20px">
    <div>
      <div>
        <el-select
          v-model="addressId"
          filterable
          clearable
          placeholder="请选择地址"
          @change="selectChange"
          style="margin-right: 5px"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-checkbox
        style="margin-bottom: 10px"
        v-model="checked"
        @change="updateEmailStatus"
        >是否启用邮箱</el-checkbox
      >
      <div>
        <el-form :inline="true" :model="formInline">
          <el-form-item label="填写邮箱号：">
            <el-input
              type="email"
              v-model="formInline.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitEmail">提交邮箱</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div>
      <div style="font-size: 16px; margin-bottom: 20px">
        设置活动有效期
        <span style="font-size: 14px"
          >（注：若不设置活动有效日期，则默认长期有效。若不设置预约时间，则默认开始时间为09:00，结束时间为18:00）</span
        >
      </div>
      <el-form
        label-position="right"
        label-width="120px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="活动有效日期" required>
          <el-date-picker
            v-model="value1"
            :picker-options="pickerOptions"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-checkbox
            style="margin-left: 10px"
            v-model="checkedDate"
            @change="changeWeekStatus"
            >是否取消周末可预约</el-checkbox
          >
        </el-form-item>
        <el-form-item label="预约时间" required>
          上午起始时间：
          <el-time-select
            placeholder="起始时间"
            v-model="ruleForm.morningStart"
            :picker-options="{
              start: '05:30',
              step: '00:30',
              end: '12:30',
            }"
          >
          </el-time-select>
          <el-time-select
            style="margin-bottom: 8px"
            placeholder="结束时间"
            v-model="ruleForm.morningEnd"
            :picker-options="{
              start: '05:30',
              step: '00:30',
              end: '12:30',
              minTime: ruleForm.morningStart,
            }"
          >
          </el-time-select
          ><br />
          下午起始时间：
          <el-time-select
            placeholder="起始时间"
            v-model="ruleForm.afternoonStart"
            :picker-options="{
              start: '13:30',
              step: '00:30',
              end: '22:30',
            }"
          >
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="ruleForm.afternoonEnd"
            :picker-options="{
              start: '13:30',
              step: '00:30',
              end: '22:30',
              minTime: ruleForm.afternoonStart,
            }"
          >
          </el-time-select>
        </el-form-item>
        <el-form-item label="时间段预约人数">
          <el-input-number
            v-model="ruleForm.num"
            :min="1"
            :max="50"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitDate">提交时间设置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import {
  updatetAddress,
  searchAddress,
  getAdminPlace,
  setting,
} from "@/api/api";
export default {
  // computed: {
  //   ...mapState(["userInfo"]),
  // },
  data() {
    return {
      checked: 0,
      formInline: {
        email: "",
      },
      addressId: "",
      ruleForm: {
        morningStart: null, // 上午起始小时
        morningEnd: null, // 上午结束小时
        afternoonStart: null, // 下午起始小时
        afternoonEnd: null, // 下午结束小时
        startMinute: null, // 分钟起始时间
        num: 10,
      },
      rules: {},
      value1: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      checkedDate: false,
      options: [],
    };
  },
  mounted() {
    this.userInfo = sessionStorage.getItem("userInfo");
    console.log(this.userInfo, "this.userInfo");
    if (JSON.parse(this.userInfo).placeId) {
      searchAddress({ id: JSON.parse(this.userInfo).placeId }).then((res) => {
        if (res.code == 0 && res.data.length > 0) {
          console.log(res, "emailStatus");
          this.formInline.email = res.data[0].email;
          this.checked = res.data[0].emailStatus;
          this.value1 = ["", ""];
          this.value1[0] = res.data[0].startDay;
          this.value1[1] = res.data[0].endDay;
          this.ruleForm.morningStart = Number(
            res.data[0].morningStart.substring(0, 2)
          );
          this.ruleForm.morningEnd = res.data[0].morningEnd;
          this.ruleForm.afternoonStart = res.data[0].afternoonStart;
          this.ruleForm.afternoonEnd = res.data[0].afternoonEnd;
          this.ruleForm.startMinute = res.data[0].startMinute;
          this.checkedDate = res.data[0].weekendStatus;
          this.ruleForm.num = res.data[0].number;
        }
      });
    }

    getAdminPlace({ adminId: JSON.parse(this.userInfo).id }).then((res) => {
      console.log(res.data, "options");
      if (res.code == 0) {
        this.options = res.data;
      }
    });
  },
  methods: {
    selectChange(value) {
      this.addressId = value;
      setting({ adminId: value }).then((res) => {
        console.log(res.data, "options");
        if (res.code == 0) {
          this.formInline.email = res.data.email;
          this.checked = res.data.emailStatus;
          this.value1 = ["", ""];
          this.value1[0] = res.data.startDay;
          this.value1[1] = res.data.endDay;
          this.ruleForm.morningStart = res.data.morningStart;
          // Number(res.data.startTime.substring(0,2))
          this.ruleForm.morningEnd = res.data.morningEnd;
          this.ruleForm.afternoonStart = res.data.afternoonStart;
          this.ruleForm.afternoonEnd = res.data.afternoonEnd;
          this.ruleForm.startMinute = res.data.startMinute;
          this.checkedDate = res.data.weekendStatus;
          this.ruleForm.num = res.data.number;
        }
      });
    },
    submitEmail() {
      this.load({ Email: this.formInline.email });
    },
    updateEmailStatus() {
      this.load({ EmailStatus: this.checked });
    },
    changeWeekStatus() {
      this.load({ weekendStatus: this.checkedDate });
    },
    submitDate() {
      console.log(this.value1);
      this.load({
        startDay: this.value1 ? this.value1[0] : "",
        endDay: this.value1 ? this.value1[1] : "",
        afternoonStart: this.ruleForm.afternoonStart,
        morningStart: this.ruleForm.morningStart,
        morningEnd: this.ruleForm.morningEnd,
        afternoonEnd: this.ruleForm.afternoonEnd,
        startMinute: this.ruleForm.startMinute,
        number: this.ruleForm.num,
      });
    },
    load(data) {
      console.log(this.addressId, data, "data");
      if (!this.addressId) {
        this.$message({
          message: "请选择地点",
          type: "info",
        });
      } else {
        data.id = this.addressId;
        updatetAddress(data).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
          } else {
            if (res.code == 1105) {
              this.$message({
                message: res.msg,
                type: "info",
              });
              this.checked = false;
            }
          }
        });
      }
    },
  },
};
</script>

<style>
.managebody {
  padding: 10px 20px;
}
</style>
